import { fetchAuthTokenAPI } from "@/redux/slice/auth/apis/fetchAuthToken";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import { updateSignedInState, updateSSOToken } from "@/redux/slice/auth/slice";

export default async function updateSSOTokenFromAuthService(dispatch: any) {
  const resolvedRequest = await fetchAuthTokenAPI();
  const response = resolvedRequest?.response;
  const currentMobileNumber = response?.mobileNumber;
  const currentSSOToken = response?.authToken;

  if (currentMobileNumber && currentSSOToken) {
    localStorage.setItem("mobile_num", currentMobileNumber);
    dispatch?.(updateSSOToken(currentSSOToken));
  } else {
    dispatch?.(updateSignedInState(SignedinState.SIGNEDOUT));
  }
}
